import React from "react";
import { Link, useLocation, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import logo from "../assets/images/brand/logo.png";
import "../styles/contact-success.css";

const ContactSuccess = () => {
  const location = useLocation();
  const email = location.state?.email;

  if (!email) {
    return <Navigate to="/contacto" replace />;
  }

  return (
    <div className="success-page">
      <Helmet>
        <title>Consulta enviada | Cáceres Maquinarias</title>
      </Helmet>

      <div className="success-wrapper">
        <img src={logo} alt="Cáceres Maquinarias" className="success-logo" />

        {/* Card */}
        <div className="success-card">
          <div className="success-checkmark">
            <svg
              viewBox="0 0 52 52"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="26" cy="26" r="25" stroke="#f37a1f" strokeWidth="2" />
              <path
                d="M14 26l9 9 15-15"
                stroke="#f37a1f"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h1 className="success-title">¡Consulta enviada!</h1>
          <p className="success-subtitle">
            Recibimos tu mensaje. Te vamos a contactar a la brevedad a:
          </p>
          <p className="success-email">{email}</p>

          <p className="success-hint">
            Si no recibís respuesta en 24 horas, también podés escribirnos por
            WhatsApp.
          </p>

          <div className="success-actions">
            <a
              href="https://wa.me/5493464540919"
              target="_blank"
              rel="noopener noreferrer"
              className="success-btn success-btn--whatsapp"
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                width="18"
                height="18"
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.126 1.532 5.862L.058 23.486a.5.5 0 00.609.601l5.805-1.525A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.9a9.877 9.877 0 01-5.031-1.373l-.36-.214-3.733.981.999-3.648-.235-.374A9.861 9.861 0 012.1 12C2.1 6.533 6.533 2.1 12 2.1c5.467 0 9.9 4.433 9.9 9.9 0 5.467-4.433 9.9-9.9 9.9z" />
              </svg>
              Escribirnos por WhatsApp
            </a>
            <Link to="/productos" className="success-btn success-btn--products">
              Ver productos
            </Link>
            <Link to="/" className="success-btn success-btn--home">
              Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSuccess;
